'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdReport = function MdReport(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm21.6 21.6v-10h-3.2v10h3.2z m-1.6 7.2c1.2 0 2.2-1 2.2-2.2s-1-2.1-2.2-2.1-2.2 1-2.2 2.1 1 2.2 2.2 2.2z m6.3-23.8l8.7 8.8v12.5l-8.7 8.7h-12.5l-8.8-8.7v-12.5l8.8-8.8h12.5z' })
        )
    );
};

exports.default = MdReport;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/report.js
// module id = 2718
// module chunks = 0